import { Modal, StatusDropdown } from "components";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCreated?: (production: server.dto.ProductionSmallV2) => void;
}

interface NewProductionFormState {
  title: string;
  status: server.dto.StatusSmall;
}

export const NewProductionModal = (props: Props) => {
  const [formState, setFormState] = React.useState<NewProductionFormState>({
    title: "",
    status: site.currentEnvironment.statuses.production[0],
  });

  const onChange = (newData: Partial<NewProductionFormState>) => {
    setFormState((prevState) => ({
      ...prevState,
      ...newData,
    }));
  }

  const submit = () => {
    return window.CoreApi.Production.Create({
      name: formState.title,
      statusId: formState.status?.statusId,
    })
  }

  const onSuccess = async (productionId: number) => {
    if (props.onCreated) {
      const result = await window.CoreApi.Production.GetProduction(productionId);
      if (result.data.hasErrors) {
        return;
      }
      props.onCreated({
        ...result.data.data,
        artists: result.data.data.artists.map(artist => artist.name),
      });
    } else {
      window.location.href = routes.production_Detail(productionId).absolute;
    }
  }

  return <Modal
    isOpen={props.isOpen}
    title={site.currentEnvironment.production.newLabel}
    handleClose={props.onClose}
    width="tiny"
  >
    <div className="grow1 scrollbox-auto">
      <EditSectionTemplate
        submit={submit}
        noPanels
        onSuccess={onSuccess}
        sections={[
          {
            key: "productionDetails",
            type: "regular",
            title: site.currentEnvironment.production.newLabel,
            fields: [
              {
                key: "title",
                label: RESX.GeneralLabels.Name,
                renderEditNew: () => (
                  <RequiredTextInput
                    focusOnMount
                    maxLength={serverReference.constants.production.maxNameLength}
                    value={formState.title}
                    validatorKey="title"
                    onChange={title => onChange({ title })}
                  />
                )
              },
              {
                key: "status",
                label: RESX.Status.resxStatus,
                renderEditNew: () => (
                  <StatusDropdown
                    value={formState.status}
                    onChange={status => onChange({ status })}
                    mainArea="production"
                    options={undefined}
                  />
                )
              }
            ]
          }
        ]}
      />
    </div>
  </Modal>
}